import * as React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

import { cn } from '../../lib/utils';
import { useSidebar } from '../ui/sidebar';

export interface SidebarCollapseTriggerProps {
  /** Accessible label for the toggle button. Defaults to "Toggle Sidebar". */
  ariaLabel?: string;
  /** Optional extra classes merged via cn() */
  className?: string;
}

export function SidebarCollapseTrigger({
  ariaLabel = 'Toggle Sidebar',
  className,
}: SidebarCollapseTriggerProps): React.JSX.Element {
  const { state, toggleSidebar } = useSidebar();

  return (
    <button
      aria-label={ariaLabel}
      className={cn(
        'inline-flex h-8 w-8 items-center justify-center rounded-lg text-sidebar-foreground/60 transition-all duration-200 hover:bg-sidebar-accent hover:text-sidebar-foreground',
        className,
      )}
      onClick={toggleSidebar}
      type="button"
    >
      {state === 'expanded' ? (
        <ChevronLeft className="size-4 rtl:rotate-180" />
      ) : (
        <ChevronRight className="size-4 rtl:rotate-180" />
      )}
    </button>
  );
}
